import type { ReactNode } from 'react';
import { GridColumnFilterButton } from '../../../components/shared/GridColumnFilterPanel';
import { GridExportButton, GridSearchInput } from '../../../components/shared/GridToolbar';

type TransactionToolbarProps = {
  search: string;
  onSearchChange: (value: string) => void;
  activeColumnFilterCount: number;
  onOpenFilters: () => void;
  onExport: () => void;
  exporting: boolean;
  loading: boolean;
  hasRows: boolean;
  /** Export is a gated functionality — hidden when the user lacks the Export permission. */
  showExport?: boolean;
  /** Referral users get a plain merchant dropdown (see ReferralMerchantSelect) instead of the
   * full column-filter drawer — rendered here in place of the Filters button. */
  hideFilterButton?: boolean;
  merchantSelect?: ReactNode;
};

export default function TransactionToolbar({
  search,
  onSearchChange,
  activeColumnFilterCount,
  onOpenFilters,
  onExport,
  exporting,
  loading,
  hasRows,
  hideFilterButton = false,
  showExport = true,
  merchantSelect,
}: TransactionToolbarProps) {
  return (
    <div className="tm-toolbar-controls">
      <GridSearchInput
        value={search}
        onValueChange={onSearchChange}
        placeholder="Search name, email or country…"
        inputClassName="text-xs font-normal tm-toolbar-search-input"
        className="tm-toolbar-search"
        disabled={loading}
      />
      {merchantSelect}
      {!hideFilterButton && (
        <GridColumnFilterButton
          activeCount={activeColumnFilterCount}
          onClick={onOpenFilters}
          disabled={loading}
          className="tm-compact-icon-btn"
        />
      )}
      {showExport && (
        <GridExportButton
          onClick={onExport}
          loading={exporting}
          disabled={loading || !hasRows}
          className="tm-compact-icon-btn"
        />
      )}
    </div>
  );
}
